import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=5ede2de1&scoped=true&"
import script from "./questionnaire.vue?vue&type=script&lang=js&"
export * from "./questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire.vue?vue&type=style&index=0&lang=css&"
import style1 from "./questionnaire.vue?vue&type=style&index=1&id=5ede2de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede2de1",
  null
  
)

export default component.exports